import { render, staticRenderFns } from "./BeginBalance.vue?vue&type=template&id=5e81d244"
import script from "./BeginBalance.vue?vue&type=script&lang=js"
export * from "./BeginBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports